module.exports = __webpack_public_path__ + "img/KSAT25-45-1500-1-complete.385ee5a4.png";